//@ts-nocheck
import { BernieGraphqlClient, FetchPolicy, RequestOptions } from "bernie-graphql";
import * as generated from "./types";
import * as operations from "./operations";

export interface OperationResult<T> {
  data: T;
  errors?: [];
  extensions: any;
  headers: Headers;
}

function isFetchPolicy(requestOptions: RequestOptions | FetchPolicy): requestOptions is FetchPolicy {
  return typeof requestOptions === "string";
}

export class ApiOperations {
  public constructor(private client: BernieGraphqlClient) {
    //
  }

  public campaignRecommendationsWithOffersQuery(
    variables: generated.CampaignRecommendationsWithOffersQuery.Variables,
    options?: FetchPolicy | RequestOptions
  ): Promise<OperationResult<generated.CampaignRecommendationsWithOffersQuery.Query>> {
    let requestOptions: RequestOptions;
    let fetchPolicy: FetchPolicy;

    if (options) {
      requestOptions = isFetchPolicy(options) ? null : options;
      fetchPolicy = isFetchPolicy(options) ? options : requestOptions.fetchPolicy;
    }

    return this.client
      .query(
        {
          query: operations.campaignRecommendationsWithOffersQueryQuery,
          variables,
          fetchPolicy
        },
        requestOptions
      )
      .then(result => {
        const body = result.body;
        const data = body.data as generated.CampaignRecommendationsWithOffersQuery.Query;
        const extensions = body.extensions;
        const errors = body.errors;
        const headers = result.headers;

        return { data, errors, extensions, headers };
      });
  }

  public customerPropertySearchByIdQuery(
    variables: generated.CustomerPropertySearchByIdQuery.Variables,
    options?: FetchPolicy | RequestOptions
  ): Promise<OperationResult<generated.CustomerPropertySearchByIdQuery.Query>> {
    let requestOptions: RequestOptions;
    let fetchPolicy: FetchPolicy;

    if (options) {
      requestOptions = isFetchPolicy(options) ? null : options;
      fetchPolicy = isFetchPolicy(options) ? options : requestOptions.fetchPolicy;
    }

    return this.client
      .query(
        {
          query: operations.customerPropertySearchByIdQueryQuery,
          variables,
          fetchPolicy
        },
        requestOptions
      )
      .then(result => {
        const body = result.body;
        const data = body.data as generated.CustomerPropertySearchByIdQuery.Query;
        const extensions = body.extensions;
        const errors = body.errors;
        const headers = result.headers;

        return { data, errors, extensions, headers };
      });
  }

  public customerSearchHistoryAllQuery(
    variables: generated.CustomerSearchHistoryAllQuery.Variables,
    options?: FetchPolicy | RequestOptions
  ): Promise<OperationResult<generated.CustomerSearchHistoryAllQuery.Query>> {
    let requestOptions: RequestOptions;
    let fetchPolicy: FetchPolicy;

    if (options) {
      requestOptions = isFetchPolicy(options) ? null : options;
      fetchPolicy = isFetchPolicy(options) ? options : requestOptions.fetchPolicy;
    }

    return this.client
      .query(
        {
          query: operations.customerSearchHistoryAllQueryQuery,
          variables,
          fetchPolicy
        },
        requestOptions
      )
      .then(result => {
        const body = result.body;
        const data = body.data as generated.CustomerSearchHistoryAllQuery.Query;
        const extensions = body.extensions;
        const errors = body.errors;
        const headers = result.headers;

        return { data, errors, extensions, headers };
      });
  }

  public customerSearchHistoryQuery(
    variables: generated.CustomerSearchHistoryQuery.Variables,
    options?: FetchPolicy | RequestOptions
  ): Promise<OperationResult<generated.CustomerSearchHistoryQuery.Query>> {
    let requestOptions: RequestOptions;
    let fetchPolicy: FetchPolicy;

    if (options) {
      requestOptions = isFetchPolicy(options) ? null : options;
      fetchPolicy = isFetchPolicy(options) ? options : requestOptions.fetchPolicy;
    }

    return this.client
      .query(
        {
          query: operations.customerSearchHistoryQueryQuery,
          variables,
          fetchPolicy
        },
        requestOptions
      )
      .then(result => {
        const body = result.body;
        const data = body.data as generated.CustomerSearchHistoryQuery.Query;
        const extensions = body.extensions;
        const errors = body.errors;
        const headers = result.headers;

        return { data, errors, extensions, headers };
      });
  }

  public dxPropertySearchQuery(
    variables: generated.DxPropertySearchQuery.Variables,
    options?: FetchPolicy | RequestOptions
  ): Promise<OperationResult<generated.DxPropertySearchQuery.Query>> {
    let requestOptions: RequestOptions;
    let fetchPolicy: FetchPolicy;

    if (options) {
      requestOptions = isFetchPolicy(options) ? null : options;
      fetchPolicy = isFetchPolicy(options) ? options : requestOptions.fetchPolicy;
    }

    return this.client
      .query(
        {
          query: operations.dxPropertySearchQueryQuery,
          variables,
          fetchPolicy
        },
        requestOptions
      )
      .then(result => {
        const body = result.body;
        const data = body.data as generated.DxPropertySearchQuery.Query;
        const extensions = body.extensions;
        const errors = body.errors;
        const headers = result.headers;

        return { data, errors, extensions, headers };
      });
  }

  public mapPropertySearchById(
    variables: generated.MapPropertySearchById.Variables,
    options?: FetchPolicy | RequestOptions
  ): Promise<OperationResult<generated.MapPropertySearchById.Query>> {
    let requestOptions: RequestOptions;
    let fetchPolicy: FetchPolicy;

    if (options) {
      requestOptions = isFetchPolicy(options) ? null : options;
      fetchPolicy = isFetchPolicy(options) ? options : requestOptions.fetchPolicy;
    }

    return this.client
      .query(
        {
          query: operations.mapPropertySearchByIdQuery,
          variables,
          fetchPolicy
        },
        requestOptions
      )
      .then(result => {
        const body = result.body;
        const data = body.data as generated.MapPropertySearchById.Query;
        const extensions = body.extensions;
        const errors = body.errors;
        const headers = result.headers;

        return { data, errors, extensions, headers };
      });
  }

  public mapPropertySearchByLatLong(
    variables: generated.MapPropertySearchByLatLong.Variables,
    options?: FetchPolicy | RequestOptions
  ): Promise<OperationResult<generated.MapPropertySearchByLatLong.Query>> {
    let requestOptions: RequestOptions;
    let fetchPolicy: FetchPolicy;

    if (options) {
      requestOptions = isFetchPolicy(options) ? null : options;
      fetchPolicy = isFetchPolicy(options) ? options : requestOptions.fetchPolicy;
    }

    return this.client
      .query(
        {
          query: operations.mapPropertySearchByLatLongQuery,
          variables,
          fetchPolicy
        },
        requestOptions
      )
      .then(result => {
        const body = result.body;
        const data = body.data as generated.MapPropertySearchByLatLong.Query;
        const extensions = body.extensions;
        const errors = body.errors;
        const headers = result.headers;

        return { data, errors, extensions, headers };
      });
  }

  public propertyFiltersQuery(
    variables: generated.PropertyFiltersQuery.Variables,
    options?: FetchPolicy | RequestOptions
  ): Promise<OperationResult<generated.PropertyFiltersQuery.Query>> {
    let requestOptions: RequestOptions;
    let fetchPolicy: FetchPolicy;

    if (options) {
      requestOptions = isFetchPolicy(options) ? null : options;
      fetchPolicy = isFetchPolicy(options) ? options : requestOptions.fetchPolicy;
    }

    return this.client
      .query(
        {
          query: operations.propertyFiltersQueryQuery,
          variables,
          fetchPolicy
        },
        requestOptions
      )
      .then(result => {
        const body = result.body;
        const data = body.data as generated.PropertyFiltersQuery.Query;
        const extensions = body.extensions;
        const errors = body.errors;
        const headers = result.headers;

        return { data, errors, extensions, headers };
      });
  }

  public queryPropertyHeroImage(
    variables: generated.QueryPropertyHeroImage.Variables,
    options?: FetchPolicy | RequestOptions
  ): Promise<OperationResult<generated.QueryPropertyHeroImage.Query>> {
    let requestOptions: RequestOptions;
    let fetchPolicy: FetchPolicy;

    if (options) {
      requestOptions = isFetchPolicy(options) ? null : options;
      fetchPolicy = isFetchPolicy(options) ? options : requestOptions.fetchPolicy;
    }

    return this.client
      .query(
        {
          query: operations.queryPropertyHeroImageQuery,
          variables,
          fetchPolicy
        },
        requestOptions
      )
      .then(result => {
        const body = result.body;
        const data = body.data as generated.QueryPropertyHeroImage.Query;
        const extensions = body.extensions;
        const errors = body.errors;
        const headers = result.headers;

        return { data, errors, extensions, headers };
      });
  }

  public queryPropertyReviewsHeadline(
    variables: generated.QueryPropertyReviewsHeadline.Variables,
    options?: FetchPolicy | RequestOptions
  ): Promise<OperationResult<generated.QueryPropertyReviewsHeadline.Query>> {
    let requestOptions: RequestOptions;
    let fetchPolicy: FetchPolicy;

    if (options) {
      requestOptions = isFetchPolicy(options) ? null : options;
      fetchPolicy = isFetchPolicy(options) ? options : requestOptions.fetchPolicy;
    }

    return this.client
      .query(
        {
          query: operations.queryPropertyReviewsHeadlineQuery,
          variables,
          fetchPolicy
        },
        requestOptions
      )
      .then(result => {
        const body = result.body;
        const data = body.data as generated.QueryPropertyReviewsHeadline.Query;
        const extensions = body.extensions;
        const errors = body.errors;
        const headers = result.headers;

        return { data, errors, extensions, headers };
      });
  }

  public propertySearchQuery(
    variables: generated.PropertySearchQuery.Variables,
    options?: FetchPolicy | RequestOptions
  ): Promise<OperationResult<generated.PropertySearchQuery.Query>> {
    let requestOptions: RequestOptions;
    let fetchPolicy: FetchPolicy;

    if (options) {
      requestOptions = isFetchPolicy(options) ? null : options;
      fetchPolicy = isFetchPolicy(options) ? options : requestOptions.fetchPolicy;
    }

    return this.client
      .query(
        {
          query: operations.propertySearchQueryQuery,
          variables,
          fetchPolicy
        },
        requestOptions
      )
      .then(result => {
        const body = result.body;
        const data = body.data as generated.PropertySearchQuery.Query;
        const extensions = body.extensions;
        const errors = body.errors;
        const headers = result.headers;

        return { data, errors, extensions, headers };
      });
  }

  public static withClient(client: BernieGraphqlClient) {
    return new ApiOperations(client);
  }
}
